<script setup lang="ts">
import { useAlertStore } from "~/stores/alert";

const alertStore = useAlertStore();
</script>

<template>
	<div class="fixed z-50 bottom-5 right-5 grid gap-y-2">
		<AppAlert
			v-for="alert in alertStore.getLatestUnreadAlert"
			v-show="alert.unread"
			:key="alert.id"
			:title="alert.title"
			:description="alert.description"
			:status="alert.status"
			@close="alert.unread = false"
		/>
		<AppAlertLoading
			v-for="alert in alertStore.loadingAlerts"
			:key="alert.id"
			:title="alert.title"
		/>
	</div>
</template>
